import { rootStore } from "@/store/RootStore";

/**
 * Adds the admin's selected currency to the params of an admin call.
 *
 * Read when the call is made, so a call always carries the current choice. A
 * `currency` already in `params` wins.
 */
export function withAdminCurrency<T extends object>(
  params?: T
): T & { currency: string } {
  return { currency: rootStore.currencyFilter.currency, ...params } as T & {
    currency: string;
  };
}
